import { useSite } from "@/context/SiteContext";

export default function Marquee({ variant = "primary" }) {
  const { site } = useSite();
  const text = variant === "secondary" ? site.marquee.secondary : site.marquee.primary;
  const secondary = variant === "secondary" ? site.marquee.primary : site.marquee.secondary;

  const items = Array.from({ length: 10 }, (_, i) => (
    <span key={i} className="flex items-center gap-8 px-8">
      <span className="font-serif italic text-2xl md:text-4xl font-light">{text}</span>
      <span className="text-stone-400 text-xl">✧</span>
      <span className="font-sans text-xs uppercase tracking-[0.4em] text-stone-500">{secondary}</span>
      <span className="text-stone-400 text-xl">✧</span>
      <span className="font-serif italic text-2xl md:text-4xl font-light">Jenova Collective</span>
      <span className="text-stone-400 text-xl">✧</span>
    </span>
  ));

  return (
    <div className="w-full overflow-hidden bg-[#EBE8E0] py-6 md:py-8 border-y border-stone-300/40">
      <div className="marquee-track text-[#8A8D8A]">
        {items}
        {items}
      </div>
    </div>
  );
}
